import {useRouter} from 'next/router';
import {useEffect, useState} from 'react';
import dynamic from 'next/dynamic';
import Cookies from 'js-cookie';

import styles from '@styles/product/multi.module.scss';
import ProductDetail from '@components/product/detail/ProductDetail';
import {api} from '@utils/api';
import Loading from '@components/Loading';
import {useApp} from '@context/AppProvider';
const AgeValidatorModal = dynamic(() => import('@models/ageValidator.modal'));
import {ageVerified} from '@utils/functions';
function Product(props) {
	const {
		product,
		brand,
		mas,
		currencyData,
		promotions,
		settings,
		queryParams,
		isBrand,
		session,
	} = props;
	const [init, setInit] = useState({
		load: true,
		preState: null,
	});

	const [data, setData] = useState({
		isModalShow: false,
		listLoadProduct: false,
		isoCode: null,
		showRegisterPop: false,
	});

	const router = useRouter();
	const {
		idb: {isoCode, showRegisterPop},
		setIdb,
	} = useApp();

	useEffect(() => {
		if (session && session === 'notExist') {
			router.reload();
		} else {
			const preState = sessionStorage.getItem('productState');
			sessionStorage.removeItem('productState');
			if (preState) {
				setInit({...init, preState: JSON.parse(preState), load: false});
			} else {
				setInit({...init, load: false});
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [session, router]);

	useEffect(() => {
		const init = () => {
			let obj = {};
			const ageActive = product?.retailers.find(
				item => item?.storeDetail?.isChecked,
			);
			if (isoCode.toLowerCase() === 'nz' && ageActive?.storeDetail?.isChecked) {
				obj = {
					isModalShow: true,
					listLoadProduct: true,
				};
			} else {
				obj = {
					isModalShow: false,
					listLoadProduct: true,
				};
			}
			setData(preState => ({
				...preState,
				...obj,
			}));
		};

		if (isoCode && !data.listLoadProduct && !showRegisterPop) {
			init();
		}
	}, [isoCode, showRegisterPop, data.listLoadProduct, product?.retailers]);

	useEffect(() => {
		if (
			isoCode !== null &&
			!Cookies.get('isoCode') &&
			isoCode.toLowerCase() !== data?.isoCode?.toLowerCase()
		) {
			setData(preState => ({
				...preState,
				listLoadProduct: false,
				isoCode: isoCode,
			}));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isoCode]);

	useEffect(() => {
		if (showRegisterPop && isoCode) {
			let obj = {};
			if (isoCode.toLowerCase() === 'nz' && !ageVerified()) {
				setTimeout(() => {
					setIdb(val => ({...val, showRegisterPop: false}));
				}, 3000);
				obj = {
					showRegisterPop: true,
				};
			} else {
				obj = {
					isModalShow: false,
					listLoadProduct: true,
				};
			}
			setData(preState => ({
				...preState,
				...obj,
			}));
		}
	}, [data.listLoadProduct, isoCode, setIdb, showRegisterPop]);

	if (!data.isModalShow && !data.listLoadProduct) {
		return <Loading />;
	}

	if ((session && session === 'notExist') || init.load) {
		return <Loading />;
	}

	return (
		<>
			{data.listLoadProduct &&
				(data.isModalShow ? (
					<AgeValidatorModal
						callback={() => {
							if (data.showRegisterPop)
								setIdb(val => ({...val, showRegisterPop: true}));
							setData(preState => ({
								...preState,
								isModalShow: false,
								showRegisterPop: false,
							}));
						}}
					/>
				) : (
					<ProductDetail
						styles={styles}
						currencyData={currencyData}
						product={product}
						brand={brand}
						mas={mas}
						promotions={promotions}
						settings={settings}
						queryParams={queryParams}
						isStore={false}
						isBrand={isBrand}
						isModal={false}
						initData={init.preState}
					/>
				))}
		</>
	);
}

Product.Layout = true;

export default Product;

export async function getServerSideProps(ctx) {
	const {query} = ctx;
	const slug = query.slug[0];

	try {
		const result = await api(
			{
				url: `/product/${slug}/true`,
				method: 'GET',
				params: query,
			},
			ctx,
		);
		let meta = {};

		if (result && result.product) {
			const productName = result.product.product_name;
			const category = result.product.categories.find(c => c.selected);
			meta = {
				title: `${productName}  | Better That`,
				description: `Buy ${productName} and heaps of other ${
					category && category.path
				} products at Better That and give back to Good Causes with every purchase. It&#039;s shopping- but Better!`,
				keywords: `Buy ${productName} online`,
			};
		} else if (result.url && result.url === 'notExist') {
			return {
				redirect: {
					destination: '/',
					permanent: false,
				},
			};
		}
		return {
			props: {
				...result,
				queryParams: query,
				isBrand: query.slug.length > 1 ? true : false,
				meta,
			},
		};
	} catch (error) {
		return {
			props: {
				session: 'notExist',
			},
		};
	}
}
